<div class="modal-container">
  <div class="header-container">{{ configs[currentMode].title }}</div>
  <div class="form-container">
    <div class="brand-container">
      <div class="brand-name-container">
        <app-titled-input [control]="name" [title]="'Brand name'">
          <ng-content>
            <input type="text" [formControl]="name">
          </ng-content>
        </app-titled-input>
      </div>
      <div class="brand-key-container">
        <app-titled-input [control]="brandKey" [title]="'Brand key'">
          <ng-content>
            <input type="text" [formControl]="brandKey">
          </ng-content>
        </app-titled-input>

      </div>
    </div>
    <div class="select-menu-input-wrapper">
      <app-titled-input [control]="competingBrands" [title]="'Competitors'">
      </app-titled-input>
      <app-select-menu [items]="competitorOptions" [placeholder]="'Select brand'" [searchable]="true" [groupBySelected]="true"
        [virtualScroll]="true" [control]="competingBrands" [selectMode]="SelectMode.MULTI" [selectAllAndClearOptions]="true"></app-select-menu>
    </div>
    <div class="logo-container">
      <div class="logo">
        <app-loader *ngIf="logoLoading"></app-loader>
        <img [src]="logoPath.value" (error)="onLogoError($event)">
      </div>
      <div class="controls">
        <div class="buttons">
          <app-button class="find" [class]="!name.value || logoLoading ? 'disabled' : 'primary'"
            text="Find automatically" (clicked)="findLogo()"></app-button>
          <app-button class="upload" [class]="!name.value || logoLoading ? 'disabled' : 'secondary'"
            text="Upload a logo" (clicked)="uploadLogo()"></app-button>
        </div>
        <span class="note">* .jpg or .png file up to 2MB. Image should be square.</span>
        <span class="message" [class]="logoMessageState.class">{{ logoMessageState.message }}</span>
      </div>
    </div>
    <div class="search-domains-container">
      <div class="title-and-copy-container">
        Advertiser domains
        <button (click)="copyAdvertiserDomains()" class="copy-button"><img
            [src]="'svg/copy.svg' | assetVersion"></button>
      </div>
      <app-form-chip-list [chips]="selectedResults" [control]="advertiserDomains"></app-form-chip-list>
      <div class="search-bar-container">
        <div class="search-bar">
          <app-search-bar (onSubmitSearch)="search()" placeholder="Search advertiser domains..."
            [searchControl]="searchControl"></app-search-bar>
        </div>
        <div class="search-button">
          <app-button text="Search" [class]="getValidSearch() ? 'primary' : 'primary disabled'"
            (clicked)="search()"></app-button>
        </div>
      </div>
    </div>
    <app-search-result-list [results]="unselectedResults" [placeholder]='resultPlaceholder'
      [resultClickCallback]="redirectCallback" [isLoading]="isSearching"></app-search-result-list>
    <div class="add-domain-container">
      <app-titled-input [control]="manualAdvertiserDomain">
        <ng-content>
          <input type="text" class="add-domain-input" [formControl]="manualAdvertiserDomain"
            placeholder="Type advertiser domain to add it manually">
        </ng-content>
      </app-titled-input>
      <app-button text="Add manual advertiser domain" [class]="'secondary'"
        (clicked)="addManualAdvertiserDomain()"></app-button>
    </div>
    <app-titled-input [control]="keywords" [title]="'Keywords for brand detection in content (separated with comma)'">
      <app-tooltip-icon [text]="tooltips.keywords"></app-tooltip-icon>
      <ng-content>
        <textarea type="text" [formControl]="keywords"></textarea>
      </ng-content>
    </app-titled-input>
    <div class="select-menu-input-wrapper">
      <app-titled-input [control]="aiPresenceTopics" [title]="'Ai Presence Topics'">
      </app-titled-input>
      <app-select-menu [items]="topicOptions" [searchable]="true" [control]="aiPresenceTopics"
        [selectMode]="SelectMode.MULTI" [selectAllAndClearOptions]="true"></app-select-menu>
    </div>
  </div>
  <div class="buttons-container">
    <app-button (clicked)="cancel()" class="cancel" text="cancel"></app-button>
    <app-button (clicked)="submit()" [class]="form.invalid? 'primary disabled' : 'primary'"
      [text]="configs[currentMode].submitText"></app-button>
  </div>
</div>
